<template>
	<div class="d-flex min-vh-100 align-items-center text-center">
		<CContainer>
			<h1>
				Oops! 403 <br>
				Access Not Granted.
			</h1>
			<CButton
				:to="{
					path: '/'
				}"
				color="secondary"
				class="mt-4"
			>
				Return to Home
			</CButton>
		</CContainer>
	</div>
</template>

<script>
export default {
	name: 'PagePermissionDenied',
};
</script>